export const TABLE_CELL_PADDING_THEME_UNITS = 1.5;
